import { SamplingTypes } from '../../shared/campaign-enums';

export const TYPE_SAMPLING_LABEL = {
  [SamplingTypes.SAMPLING_ON_TOP]: 'On top Sampling',
  [SamplingTypes.SAMPLING_IDEAL]: 'Segmented Sampling'
};
